import Accordion from 'src/components/section/Accordion';
import { Grid, Typography } from '@material-ui/core';
import { REASON_OF_ADDING_CONTACT, TITLE } from 'src/constants/contactImportant';

const ContactImportance = () => {
  return (
    <Accordion subtitle={TITLE} flexDirection={'column'}>
      <Grid spacing={2} container>
        <Grid item xs={12}>
          <Typography variant="body2">{REASON_OF_ADDING_CONTACT}</Typography>
        </Grid>
      </Grid>
    </Accordion>
  );
};

export default ContactImportance;
